/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * A field of the reviewed content of a Hub
 */
export enum HubContentField {
  name = 'name',
  description = 'description',
  coverImageKey = 'coverImageKey',
  photoKeys = 'photoKeys'
}
